var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleQuotes(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 44,
    viewBox: "0 0 55 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4905 37.4388L47.1069 37.4388L47.1069 21.8686L39.9806 21.8686L39.9806 19.594C39.9806 18.1943 40.3556 17.0537 41.0992 16.1788C41.8429 15.3051 43.0178 14.8717 44.6184 14.8717L48.5649 14.8717L48.5649 6.56123L43.7574 6.56123C40.1035 6.56147 37.2818 7.40753 35.2925 9.10499L34.4944 9.8803C32.4924 12.0965 31.4905 15.161 31.4905 19.0686L31.4905 37.4388ZM22.0515 37.4388L22.0515 21.8686L14.9314 21.8686L14.9314 19.594C14.9314 18.1943 15.3002 17.0537 16.0438 16.1788C16.6019 15.5227 17.4033 15.1123 18.4444 14.9486L19.563 14.8717L23.5095 14.8717L23.5095 6.56123L18.702 6.56123C15.0483 6.56169 12.2262 7.40727 10.2371 9.10499L9.43899 9.88029C7.68782 11.8188 6.70481 14.4072 6.48538 17.6397L6.4351 19.0686L6.4351 37.4388L22.0515 37.4388ZM2.17957e-06 19.0686L0.0628457 17.1848C0.361037 12.8268 1.74083 8.72351 4.70693 5.43993C8.36112 1.39474 13.49 0.000522799 18.702 -3.17327e-06L29.9446 -2.19041e-06L29.9446 5.24771C33.5865 1.3527 38.6298 0.000265598 43.7574 -9.82857e-07L55 0L55 21.4329L53.542 21.4329L53.542 44L0 44L2.17957e-06 19.0686Z",
    fill: "#4242CE",
    fillOpacity: 0.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleQuotes);
export default __webpack_public_path__ + "static/media/double-quotes.eb3c10577c15eec4388f5e575009aac8.svg";
export { ForwardRef as ReactComponent };